import { postRawRequest } from '../../httpClient';

export async function relinkClipsApi(collectionId: number): Promise<Response> {
  return postRawRequest({
    path: `/sys/pipeline/${collectionId}/relink-clips`,
    options: { timeout: 300_000 },
  });
}
